// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SJyv","col":"styles_col__gd3xS"};